import classNames from 'classnames';

import Button from 'molecules/Button';
import RichText from 'molecules/RichText';

import styles from 'components/ConversionPanel/conversionPanel.module.scss';

import type { ConversionPanelProps } from 'components/ConversionPanel/config';
import type { FC } from 'react';

const ConversionPanel: FC<ConversionPanelProps> = ({ body, button, backgroundColor = 'white' }) => {
  const isLight = ['blue', 'white', 'gray', 'lightgray', 'wgray80'].includes(backgroundColor);
  const wrapperClass = classNames(isLight ? styles.light : styles.dark, {
    [styles.bkgBlue]: backgroundColor === 'blue',
    [styles.bkgGray]: backgroundColor === 'gray',
    [styles.bkgTeal]: backgroundColor === 'teal',
    [styles.bkgWhite]: backgroundColor === 'white',
    [styles.bkLightGray]: backgroundColor === 'lightgray',
    [styles.bkAsh]: backgroundColor === 'ash',
    [styles.bkDarkAsh]: backgroundColor === 'darkash',
    [styles.bkCarbon]: backgroundColor === 'carbon',
    [styles.bkWGray80]: backgroundColor === 'wgray80',
    [styles.bkGreige]: backgroundColor === 'greige',
  });

  return (
    <div className={wrapperClass}>
      <div className={`${styles.container} `}>
        {body ? (
          <RichText content={body.replace(/\\n/g, '\n')} light={!isLight} className={styles.bodyStyle} />
        ) : (
          <p>&nbsp;</p>
        )}
        {button?.label && (
          <Button {...button} className={button.textStyle === 'upper' ? styles.upper : styles.standard} />
        )}
      </div>
    </div>
  );
};

export default ConversionPanel;
